import { atom } from "jotai";
import { workspaceUserPermissionsAtom } from "./workspace.userPermissions.atoms";
import { GetWorkspaceUserPermissionsUseCase } from "@/core/usecases/workspace";
import { WorkSpaceRepository } from "@/infrastructure/repositories/workspace";
import { AuthRepository } from "@/infrastructure/repositories/auth";

// Actions to set the workspace user permissions
export const setWorkspaceUserPermissionsAtom = atom(null, async (_get, set) => {
  const permissions = await new GetWorkspaceUserPermissionsUseCase(new WorkSpaceRepository(new AuthRepository())).execute();
  set(workspaceUserPermissionsAtom, {
    permissions,
  });
});
